export class UserPrefsExchangeModel {
  public SerializedUserPrefs: string;
}
